import scrollMonitor from 'scrollmonitor'

export default () => {
  const wrapper = document.querySelector('.js-product-gallery')
  if (!wrapper) return

  const targets = wrapper.querySelectorAll('.js-gallery-target')
  ;[...targets].forEach(target => {
    const targetWatcher = scrollMonitor.create(target)
    const link = document.querySelector(`a[href="#${target.id}"]`)

    targetWatcher.stateChange(() => {
      if (link) {
        if (targetWatcher.isFullyInViewport) {
          link.classList.add('active')
        } else {
          link.classList.remove('active')
        }
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/GalleryMenu.js